<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import BrandMark from '@/components/ui/BrandMark.vue'

const route = useRoute()
const section = computed(() => route.meta?.section || 'finance')

const links = computed(() => {
  return section.value === 'spiritual'
      ? [
        { label: 'Home', to: '/spiritueel' },
        { label: 'Spirituele coaching', to: '/spirituele-coaching' },
        { label: 'Wie ben ik', to: '/wie-ben-ik-2' },
        { label: 'Contact', to: '/contact-2' },
      ]
      : [
        { label: 'Home', to: '/' },
        { label: 'Financiële coaching', to: '/financiele-coaching' },
        { label: 'Wie ben ik', to: '/wie-ben-ik' },
        { label: 'Contact', to: '/contact' },
      ]
})

function toTop() {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' })
}
</script>

<template>
  <footer class="site-footer">
    <div v-if="section === 'finance'" class="finance-slogan">
      <span class="name">Serviceburo de Wilde</span>
      <p>Financiën zijn persoonlijk.</p>
      <p><em>Dus waarom zou je advies dat niet zijn?</em></p>
    </div>

    <div class="wrap footer-bar">
      <div class="footer-left">
        <BrandMark size="sm" />
        <span class="footer-dot">•</span>
        <small>© {{ new Date().getFullYear() }}</small>
      </div>

      <nav class="footer-nav" aria-label="Footer">
        <router-link v-for="l in links" :key="l.to" :to="l.to">{{ l.label }}</router-link>
      </nav>

      <!-- Shown only on the slim mobile footer (see base.css) -->
      <button type="button" class="footer-top" @click="toTop">
        <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 19V6M6 12l6-6 6 6" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        Naar boven
      </button>
    </div>
  </footer>
</template>

<style scoped>
/* Uses base.css for most styles */
</style>
